import { render, staticRenderFns } from "./NsfwAI.vue?vue&type=template&id=3d458f4a&scoped=true"
import script from "./NsfwAI.vue?vue&type=script&lang=js"
export * from "./NsfwAI.vue?vue&type=script&lang=js"
import style0 from "./NsfwAI.vue?vue&type=style&index=0&id=3d458f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d458f4a",
  null
  
)

export default component.exports